var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"secContact"}},[_c('h2',{attrs:{"id":"hContact"}},[_vm._v(_vm._s(_vm.$t("headers.contact")))]),_c('p',{staticClass:"readFriendlyLayout",attrs:{"id":"pContactInfo"}},[_vm._v(" "+_vm._s(_vm.$t("view.contact.text"))+" ")]),_c('SocialMedia'),_c('ContactForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }